var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4114_4987)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C4.47714 0 0 4.47714 0 10C0 15.5229 4.47714 20 10 20C15.5229 20 20 15.5229 20 10C20 4.47714 15.5229 0 10 0Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0571 9.94325C11.6323 9.45637 10.7439 8.56805 10.2569 3.14307C10.2482 3.04745 10.1745 3 10.1 3C10.0263 3 9.95182 3.04745 9.94306 3.14307C9.45619 8.56792 8.56786 9.45631 3.14288 9.94325C2.95237 9.96004 2.95237 10.2396 3.14288 10.2564C8.56774 10.7433 9.45613 11.6316 9.94306 17.0566C9.95182 17.1522 10.0255 17.1996 10.1 17.1996C10.1737 17.1996 10.2482 17.1522 10.2569 17.0566C10.7438 11.6317 11.6321 10.7433 17.0571 10.2564C17.2476 10.2396 17.2476 9.96004 17.0571 9.94325Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4114_4987"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenai);
export default __webpack_public_path__ + "static/media/genai.784d173772ae3512517b305d8ca2ab38.svg";
export { ForwardRef as ReactComponent };